<template>
    <Button
        has-only-icon
        variant="light"
        size="sm"
        class="sidebar-pin-button"
        :class="{'sidebar-pin-button--pinned': pinned}"
        cypress-id="sidebar-pin-button"
        :aria-pressed="pinned"
        :aria-label="pinned ? 'Unpin sidebar' : 'Pin sidebar'"
        @click="pinned = !pinned"
    >
        <PinIcon />
    </Button>
</template>

<script lang="ts" setup>
import Button from '../Elements/Button.vue';
import PinIcon from '@/images/pin.svg?component';

const pinned = defineModel<boolean>({ default: false });
</script>

<style lang="scss" scoped>
@use '@/styles/abstracts/spacings';
@use '@/styles/abstracts/mixins';

.sidebar-pin-button--pinned:not(:disabled):not(.disabled) {
    padding: spacings.$spacing-xxxs;

    background-color: var(--theme-color-button-primary) !important;
    border: none;

    svg {
        fill: var(--theme-color-icon-inversed);
    }

    @include mixins.hover-only {
        background-color: var(--theme-color-surface-inversed-primary-hover) !important;
    }
}
</style>
